import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Icon } from 'semantic-ui-react';
import './IconElement.css';
var horizontalAlignment = {
  display: 'inline-flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center'
};
var verticalAlignment = {
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  display: 'inline-flex',
  flexDirection: 'column'
};
var IconElement = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IconElement, _React$PureComponent);
  var _super = _createSuper(IconElement);
  function IconElement() {
    _classCallCheck(this, IconElement);
    return _super.apply(this, arguments);
  }
  _createClass(IconElement, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        iconType = _this$props.iconType,
        iconSize = _this$props.iconSize,
        iconPosition = _this$props.iconPosition,
        element = _this$props.element,
        className = _this$props.className,
        onClick = _this$props.onClick;
      var horizontal = iconPosition === 'left' || iconPosition === 'right';
      var elementFirst = iconPosition === 'right' || iconPosition === 'bottom';
      return /*#__PURE__*/React.createElement("div", {
        onClick: onClick,
        className: "ie-base-class ".concat(horizontal && 'ie-horiz', " ").concat(className),
        style: horizontal ? horizontalAlignment : verticalAlignment,
        role: "button",
        onKeyDown: onClick,
        tabIndex: -1
      }, elementFirst && element, /*#__PURE__*/React.createElement(Icon, {
        name: iconType,
        size: iconSize
      }), !elementFirst && element);
    }
  }]);
  return IconElement;
}(React.PureComponent);
export { IconElement as default };
IconElement.defaultProps = {
  className: '',
  element: /*#__PURE__*/React.createElement("h2", null, "Sample Element"),
  iconPosition: 'left',
  iconSize: 'large',
  iconType: 'phone',
  onClick: null
};